var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload",on:{"click":_vm.handleClick}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "+_vm._s(_vm.text)+" "),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.fileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }